import { Features, FeatureVariants } from 'common/types/search-response-cio-request';

interface ExperimentType {
  id: string;
  cohortId: string;
}

const runningExps = [
  {
    type: 'search',
    enabled: false,
    conTestName: 'use_reranker_service_for_search',
    control: 'search_reranker_v0_rpv_price_top100_tvg',
    variant: 'search_reranker_v0_rpv_price_broken_sizes_top100_tvg',
    vgTestName: 'constructor_search_reranker',
  },
  {
    type: 'browse',
    enabled: true,
    conTestName: 'use_reranker_service_for_browse',
    control: 'browse_reranker_v0_rpv_price_top100_tvg',
    variant: 'browse_reranker_v0_rpv_price_broken_sizes_top100_tvg',
    vgTestName: 'constructor_browse_reranker',
  },
  {
    type: 'promo',
    enabled: true,
    conTestName: 'use_reranker_service_for_browse',
    control: 'browse_reranker_v0_rpv_price_top100_tvg',
    variant: 'browse_reranker_v0_rpv_price_broken_sizes_top100_tvg',
    vgTestName: 'constructor_browse_reranker',
  },
];

export const getExperimentValue = (
  metaFeatures: Features | false,
  metaFeaturesVariant: FeatureVariants | false,
  pageType: string,
) => {
  const experiments: ExperimentType[] = [];

  if (!metaFeatures || !metaFeaturesVariant) return experiments;

  runningExps.forEach((arrayItem) => {
    const { type, enabled, conTestName, variant, vgTestName } = arrayItem;

    if (!enabled || type !== pageType) return;

    const featureValue = metaFeatures[conTestName as keyof typeof metaFeatures];
    const featureVariant = metaFeaturesVariant[conTestName as keyof typeof metaFeaturesVariant];

    const isInVariantPot = featureValue && featureVariant === variant ? 'variant' : 'control';

    experiments.push({ id: vgTestName, cohortId: isInVariantPot });
  });

  return experiments;
};

/* eslint-disable security/detect-object-injection */
export const EXPERIMENTS = {
  VERY_PAY_WIDGET: 'se-19',
} as const;

export function isInExperimentControl(
  experiments: Record<string, string> | undefined,
  experimentId: string,
  controlValue: string,
): boolean {
  return experiments?.[experimentId] === controlValue;
}

export function isInExperimentVariant(
  experiments: Record<string, string> | undefined,
  experimentId: string,
  variant: string,
): boolean {
  return experiments?.[experimentId] === variant;
}
